import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtilsService } from '../../shared/utils.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ModalComponent implements OnInit {
  constructor(public utils: UtilsService) {}

  ngOnInit() {}
}
